import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export const homeHeaderSlider = () => {
    const sliderEl = document.querySelector('.home-header-slider');
    const slideItemEl = document.querySelectorAll('.home-header-slider__item');
    const constHomeHeaderSlider = new Swiper(sliderEl, {
        modules: [Navigation, Pagination],
        loop: true,
        speed: 650,
        autoplay: {
            delay: 5000,
        },
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });

    constHomeHeaderSlider.on('slideChange', swiper => {
        if (!slideItemEl || slideItemEl.length === 0) return;

        const { el, realIndex } = swiper;
        const activeSlideEl = slideItemEl[realIndex];

        if (!activeSlideEl) return;

        const bgTheme = activeSlideEl.getAttribute('data-bg-theme');
        el.setAttribute('data-bg-theme', bgTheme);
    });
};

homeHeaderSlider();
